import { Translatable, TranslateProperty } from '../../../core/helper/translatables';
import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import {
  B2CSubscriptionImportAction,
  B2CSubscriptionImportActionToString,
  B2CSubscriptionImportState,
  B2CSubscriptionImportStateToString,
} from '../const/enum-b2c';
import { B2CSubscriptionIdentity } from './b2c-subscription-identity';

// An event on the subscription itself [imported from bank / EFA]
export class B2CSubscriptionImportEvent extends ModelBase {
  constructor() {
    super();
    TranslateProperty(this as B2CSubscriptionImportEvent, 'action', B2CSubscriptionImportActionToString);
    TranslateProperty(this as B2CSubscriptionImportEvent, 'state', B2CSubscriptionImportStateToString);
  }

  identity: B2CSubscriptionIdentity;
  action: Translatable<B2CSubscriptionImportAction>;

  state: Translatable<B2CSubscriptionImportState>;
  stateChangedDate: Date;

  bankDate: LocalDate;
  eventDate: Date;
  importDateUtc: Date;

  /**
   * Json data object with custom properties from the import.
   * (EFA-standard allows arbitrary custom data-fields.)
   */
  embeddedValues: {};

  toString(culture?: string): string {
    return `${B2CSubscriptionImportActionToString(this.action.valueOf())} - ${B2CSubscriptionImportStateToString(this.state.valueOf())}`;
  }

  public static Map(source: B2CSubscriptionImportEvent): B2CSubscriptionImportEvent {
    if (!source) {
      return null;
    }
    const obj = Object.assign(new B2CSubscriptionImportEvent(), source);
    obj.identity = B2CSubscriptionIdentity.Map(source.identity);
    return obj;
  }
}
